module.exports = __webpack_public_path__ + "img/wenhao.4df3abf3.png";